var _style, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _path19, _circle2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle3, _path36, _path37, _circle4, _path38, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 494.8 433.2",
    style: {
      enableBackground: "new 0 0 494.8 433.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st4{fill:#c6c2c2}.st6{fill:#1e2932}.st7{fill:#2f3d60}.st8{fill:#e89671}.st9{fill:#ece6e6}.st12{fill:#f3f4f5}.st13{fill:#f9b284}.st14{fill:#2a3843}.st15{fill:#4b5964}.st16{fill:#9f2325}.st17{fill:#ed7373}.st18{fill:#fff}.st20{fill:#322a1e}.st21,.st22{fill:none;stroke-miterlimit:10}.st21{stroke:#c77a5b;stroke-linecap:round;stroke-linejoin:round}.st22{stroke:#1e2932}.st23{fill:#1b273d}.st24{fill:#b2a6a6}.st29{fill:#283945}.st31{fill:#ffece0}.st32{fill:#838383}.st33{fill:#5a5b5c}.st34{fill:#f0f3ef}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.034,
    y1: 97.769,
    x2: 236.817,
    y2: 97.769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1747b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    style: {
      stopColor: "#f07279"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    style: {
      stopColor: "#ee6b73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#ea6067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    style: {
      stopColor: "#e54f57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    style: {
      stopColor: "#de3943"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d61f2a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.7 13.9 233 54.1c2.9 1 4.4 4.2 3.4 7.1l-12.8 37c-.8 2.4-3.1 4-5.7 3.7-6.3-.5-17.9.2-21 11.3-3.1 11.1 5.6 18.9 10.8 22.5 2.1 1.4 2.9 4.1 2.1 6.5l-12.7 36c-1 2.9-4.2 4.4-7.1 3.4L73.8 141.9c-2.9-1-4.5-4.2-3.5-7.1l40.3-117.4c1-3 4.2-4.5 7.1-3.5z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008108417751887489590000015375834986995374230_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.403,
    y1: 298.495,
    x2: 332.817,
    y2: 298.495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5d609"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#f5d40f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    style: {
      stopColor: "#f5ce1f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    style: {
      stopColor: "#f4c53a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f4be4c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008108417751887489590000015375834986995374230_)"
    },
    d: "m265.4 387.2-107.1-58.8c-2.7-1.5-3.7-4.9-2.2-7.6l18.7-34.4c1.2-2.2 3.8-3.4 6.2-2.8 6.2 1.6 17.7 2.8 22.6-7.7 4.9-10.4-2.4-19.6-7-24-1.8-1.8-2.2-4.5-1-6.8l18.5-33.4c1.5-2.7 4.8-3.7 7.5-2.2L329.8 268c2.7 1.5 3.7 4.9 2.3 7.6L273 385c-1.5 2.7-4.9 3.7-7.6 2.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007392383339964477740000018277432302861069474_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.888,
    y1: 165.039,
    x2: 397.443,
    y2: 165.039,
    gradientTransform: "rotate(-5.114 248.508 172.338) scale(.99998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85d3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    style: {
      stopColor: "#7ad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    style: {
      stopColor: "#5cc7e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#2cb9db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00acd3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007392383339964477740000018277432302861069474_)"
    },
    d: "m335.3 247.2-112-54.2c-2.8-1.4-4-4.8-2.5-7.5l16.9-33.5c1.3-2.5.4-5.6-2-7.2-5.2-3.4-12.5-10.8-8.1-22.8 4.1-11.2 18-10.5 24.9-9.3 2.4.4 4.8-.8 5.9-3l17.5-35.1c1.4-2.8 4.7-3.9 7.5-2.5L391.2 126c2.7 1.3 3.8 4.6 2.6 7.3l-51 111.2c-1.3 2.8-4.7 4-7.5 2.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159441854816166267860000014425633790516834492_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.405,
    y1: 232.893,
    x2: 185.079,
    y2: 232.893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85d3ea"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    style: {
      stopColor: "#7ad0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    style: {
      stopColor: "#5cc7e3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#2cb9db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00acd3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159441854816166267860000014425633790516834492_)"
    },
    d: "m59.7 150.1 118.7 37.1c3 .9 4.6 4.1 3.6 7.1l-11.8 35.6c-.9 2.7.3 5.6 2.9 6.8 5.6 2.6 14.1 8.8 11.5 21.5-2.4 11.7-16.2 13-23.2 12.9-2.4 0-4.6 1.5-5.4 3.9l-12.1 37.2c-1 2.9-4.1 4.5-7 3.6L22.3 278.3c-2.9-.9-4.5-4-3.6-6.9l34.1-117.6c.8-3 3.9-4.7 6.9-3.7z"
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 137.8,
    cy: 405.1,
    rx: 91.4,
    ry: 16.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 415.6,
    cy: 409.3,
    rx: 62.8,
    ry: 11.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.2 292.4s13.9-7.1 18.9-8c5-1 14.2-1.7 17.5-.2l-.6 3s-10.7-2.7-22.7 2.4l-12.1 4.5-1-1.7zM407.7 401.2h-10.9s-13.9 2.5-15.2 5.5c-1.3 3 3.5 2.4 3.5 2.4l24.9.1-2.3-8zM443.7 396.9s-1.4 3.2-11 1.9c0 0-4.5 3-6.7 3.5s-9 1.5-8.9 4.7c.2 3.2 3.6 2.1 3.6 2.1h10.1s13.6-1.5 16.1-4.8l-3.2-7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M411.8 303.9s-13.7 61.9-4 97.2h-10.9s-5.2-29.9-6.2-41.9c-.9-10.1-.9-35.5 1.9-50.3l2.8-14.8s22.4-11.8 35.3-7.4l2.5 15.3s.1 24.6.8 32.3l.7 7.7s5.8 52.1 9.1 55.3c0 0-1.1 2.9-11.2 1.5L420.8 353s-8.1-31.1-9-49.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M398.7 215.8c0-.2 1.6 8.7 1.6 8.7l-11.2 12.4-8.9-6.6c0-.1 16.5.4 18.5-14.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M429.8 255.7s3.3 15.3 3 19.8l-2.2 8.6s-8.2-2.5-21.1 2.3c-12.8 4.9-15.4 5.9-15.4 5.9s-15-31.5-15.5-32.9c0 0-6.9-17.1 0-27l5.4 8.1 4-5.7 1.9.5 1-.5 8 4.3 5.2-13.9c.2 0 1.9 9.3 25.7 30.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M442.2 247.8s-5.9 9-8.9 10.8c0 0-30.3-23.8-28.5-33.5 0 .1 16.9-2.4 37.4 22.7zM372.7 268.3s-11.1-1.8-14.1-10.9c0 0 13.1-21.4 21.5-24.9 0 0-6.9 8.1 0 27-.1 0-6.1 8.5-7.4 8.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102505495474834582750000015214726263764052915_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.571,
    y1: 268.248,
    x2: 317.453,
    y2: 268.248,
    gradientTransform: "matrix(-1 0 0 1 660.226 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e99671"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    style: {
      stopColor: "#e99771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#f5ab7f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9b384"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102505495474834582750000015214726263764052915_)"
    },
    d: "m342.8 264.1 12.3.1 4.1-5.3s3.6 8 13.5 9.5c0 0-6.8 9.2-17.8 9.4l-8.8-5.9c-.1-.1-.6-4.3-3.3-7.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057835144131577459530000008731007570379230862_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.594,
    y1: 275.643,
    x2: 238.077,
    y2: 275.643,
    gradientTransform: "matrix(-1 0 0 1 660.226 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e99671"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    style: {
      stopColor: "#e99771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#f5ab7f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9b384"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057835144131577459530000008731007570379230862_)"
    },
    d: "m434.5 257.5 2.4 2.5-6.7 27.3s-.9.9-2.6 2.2c-1.7 1.4-5.3 2.9-5.5 6.6-.2 3.7 4.3 5.9 4.3 5.9s7.5 3.9 9-3.7l.8-5.5s.3-2.3 1.6-4.6 10.7-21.5 10.8-26.6-5.6-11.8-7.1-13.1c.1-.1-4 6-7 9z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m378.7 233.3 5.4 8.1 4.8-6.1-7.1-4.6s-1.3-.1-1.8-.4l-1.3 3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m393.2 236.5.6 4.1s-2.5 1.3-5.6.4c0 0-.6-2.6-1.6-3.7l1.9-2.4 1.5.6 2.1-.9 1.1 1.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m400.8 280.1-9-7.6s2.6-20.1-2.5-31.9c0 0 2.2.7 5.6-.4l8 18s5.4 11.5 5.2 12.8l-7.3 9.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m401.7 223.1-10.6 11.7 8 4.3 5.2-13.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M396.7 208s-5.8-4.6-4.5-11.9c0 0 6.5-2.4 8.2-4.7 0 0 3.4 1.6 4.2 7.7.8 6.1-1.4 9.3-1.4 9.3s-2.3-3.2-6.5-.4zM363.5 206s.3-7.2 3-9.5c0 0-2-2.3-2.1-5.3 0 0-4 1.3-3.8 6.3.2 5 2.9 8.5 2.9 8.5zM397.1 183.7s-2.4 2.9-3.8 3.7c0 0-6-.2-9.8-3.7-.1 0 10.1 2.6 13.6 0z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M366 195.9s-5.2 6-1.9 16.8c0 0-.7 17.6 18.9 18.4 0 0 14.4-.4 16.6-15 0 0 4.9-.8 4.6-5-.3-4.2-4.2-4.8-5.9-3.9l-1.7.8s-5.3-4.1-4.5-11.9l-18-.8-8.1.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M379.4 201.3s-3.7-1.2-4.5-4.5c0 0 4.5 4.8 17.5-.2s11.4-11.2 11.4-11.2-5.4 4-15 1c0 0-8.6-5.9-15.1-3.4-6.6 2.4-9.7 4.6-9.4 9.4.2 4.7 8.9 10.9 15.1 8.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M375 183.6s-.6.2-.5 1.2c.1 1 1.5.5 1.5.5s.9-.5.5-1.4c-.6-.9-1.5-.3-1.5-.3zM372 186.8s1.6-.7 1.2-1.4c-.4-.7-1-1.3-2.9-.2s-5.8 4.4-4.9 5.7c.8 1.3 2.7-1.8 2.7-1.8s1.5-1.6 3.9-2.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M365.5 206.6s1.4-1.3 3.3-1.4c1.9 0 1.5-2.1 0-2-1.5.2-3 .7-3.3 3.4M387.4 203.2s-1.1-1-2.4-.8c-1.3.2-2.3 0-2.4-.6-.1-.6 0-1.5 1.7-1.3 1.8.2 2.9 1.3 3.1 2.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M373.4 221.7s2.2 5.5 7.7 4.5 5.9-7.2 5.9-7.2-6.9 3-13.6 2.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M377.3 225.8s1.3-2.1 4.1-1.2c0 0 1.4-1.4 3.6-.6 0 0-1.7 2-4.1 2.2-2.3.3-3.6-.4-3.6-.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M386.7 220.4c-.1 0-3.8 2.6-11.3 2.6l-.8-1.3s5.3 0 12.5-2.8l-.4 1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.4 216.6c.1-.1-3.4.8-4.3-1.4 0 0-.7.4-.5 1 0 0 2.2 2.5 4.8.4z",
    style: {
      fill: "#c77a5b"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-13.286 384.258 209.045)",
    className: "st18",
    cx: 384.3,
    cy: 209.1,
    r: 3.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M381 209.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8 0-1.6-1.3-2.8-2.8-2.8-1.6 0-2.8 1.2-2.8 2.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M381.2 209.7c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-13.286 369.175 211.057)",
    className: "st18",
    cx: 369.3,
    cy: 211.1,
    r: 3.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M365.9 211.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8 0-1.6-1.3-2.8-2.8-2.8-1.6 0-2.8 1.2-2.8 2.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M366.1 211.7c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4-.8-.1-1.4.6-1.4 1.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M400.7 209.1s-2.9-.8-3.4 1.5c-.5 2.2 1.6 4.2 4.3 2.6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m427.5 283.6.3 2.7-.9.2-.9-2.9zM417.9 284.3l-2.3.5.5 2.5 2.3-.5zM406.5 287.8l-1.8.7.5 2.3 2-1.5zM398 291.2l-1.5.6.8 2.3 1.5-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M399.5 297.9s.2 9.8-4.5 12.8M423.9 289.8s0 .8 1 1.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M388.6 240.5c.5.2.9.3 1.4.3.5 0 .9 0 1.4-.1.5-.1.9-.2 1.3-.4s.9-.4 1.2-.6l-.2.5c-.2-1.3-.4-2.7-.5-4.1l.2.3c-.8-.5-1.5-1-2.3-1.6.9.3 1.7.6 2.6 1l.1.1v.2c.3 1.3.6 2.7.8 4l.1.3-.3.2c-.5.3-.9.5-1.4.6-.5.2-1 .3-1.5.3s-1.1 0-1.6-.2c-.5-.1-1-.4-1.3-.8zM400.6 280c1.1-1.6 2.3-3.1 3.5-4.7l3.5-4.6-.1.2c0-.2-.1-.6-.2-.9l-.3-1c-.2-.6-.5-1.3-.8-1.9l-1.6-3.8-3.3-7.6-3.3-7.6c-1.1-2.5-2.2-5.1-3.2-7.6 1.3 2.4 2.6 4.9 3.8 7.4l3.6 7.5c1.2 2.5 2.3 5 3.4 7.6.5 1.3 1.1 2.6 1.6 3.9.2.6.5 1.3.7 2 .1.3.2.7.3 1 .1.4.2.7.2 1.2v.1l-.1.1-3.8 4.4c-1.3 1.4-2.6 2.8-3.9 4.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M432.2 303.9c.4 2.3.7 4.6.8 6.9.2 2.3.2 4.6.3 6.9 0 2.3 0 4.6-.2 6.9-.1 2.3-.3 4.6-.7 7-.4-2.3-.7-4.6-.8-6.9-.2-2.3-.2-4.6-.3-6.9 0-2.3 0-4.6.2-6.9 0-2.3.3-4.6.7-7zM411.8 303.9c-1.2 8.2-2.3 16.3-3.3 24.5-.5 4.1-1 8.2-1.4 12.3-.4 4.1-.8 8.2-1.1 12.3-.3 4.1-.6 8.2-.8 12.3-.2 4.1-.3 8.2-.2 12.3.1 4.1.2 8.2.7 12.3.4 4.1 1.1 8.1 2.4 12.1-1.7-3.8-2.6-7.9-3.3-11.9-.7-4.1-1-8.2-1.2-12.4-.4-8.3-.1-16.6.6-24.8s1.7-16.5 3-24.6c1-8.2 2.6-16.3 4.6-24.4zM442.6 397.4c-.8-.8-1.2-1.8-1.6-2.8-.4-1-.7-2.1-.9-3.1-.5-2.1-.8-4.2-.7-6.4.4 1 .7 2.1.9 3.1.3 1 .5 2.1.7 3.1l.7 3.1c.3.9.5 2 .9 3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M365.8 196.3c-.8 1.2-1.4 2.5-1.8 3.8-.4 1.3-.6 2.7-.7 4.1-.1 1.4 0 2.8.2 4.2.1.7.2 1.4.4 2.1.2.7.3 1.4.5 2v.1c-.1 2.3.3 4.7 1.1 6.8.8 2.2 2 4.2 3.7 5.9 1.6 1.7 3.6 3 5.8 3.9 2.2.9 4.5 1.5 6.8 1.9-2.4-.2-4.7-.7-7-1.5-2.2-.9-4.4-2.1-6.1-3.8-1.7-1.7-3-3.8-3.9-6.1-.8-2.3-1.2-4.7-1.1-7.1v.1c-.2-.7-.4-1.4-.5-2.1-.1-.7-.3-1.4-.3-2.1-.2-1.4-.2-2.9 0-4.3.1-1.4.4-2.8.9-4.2.5-1.3 1.1-2.6 2-3.7zM391.8 196.6c.2 2.1.6 4.2 1.3 6.1.3 1 .8 1.9 1.4 2.7.5.9 1.2 1.7 1.9 2.5-.9-.5-1.8-1.2-2.5-2.1-.4-.4-.6-.9-1-1.3-.3-.5-.5-1-.7-1.5-.4-1-.6-2.1-.7-3.2-.1-1.1-.1-2.2.3-3.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M403.8 185.4c.4 1.5-.2 3.1-.9 4.4-.8 1.3-1.9 2.4-3.1 3.4-2.4 1.9-5.2 3.2-8 4.2-.7.2-1.4.5-2.2.7-.7.2-1.5.3-2.2.5-1.5.3-3 .4-4.5.5-1.5 0-3-.1-4.5-.5s-2.9-1.2-3.7-2.4c1 1.1 2.4 1.7 3.8 2 1.4.3 2.9.3 4.4.2 1.5-.1 2.9-.3 4.4-.6.7-.1 1.4-.3 2.2-.5.7-.2 1.4-.5 2.1-.7 2.8-1 5.5-2.2 7.9-3.9 1.2-.8 2.3-1.8 3.1-3 .7-1.4 1.3-2.8 1.2-4.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M432.4 275.6c-.5-1.6-.9-3.3-1.2-4.9-.4-1.6-.7-3.3-1-4.9-.6-3.3-1.2-6.6-1.7-9.9l-.4-3 2.1 2.1 3 3h-1.3c.9-.7 1.7-1.6 2.5-2.4.8-.8 1.7-1.6 2.5-2.5 1.6-1.7 3.2-3.4 4.6-5.3-.9 2.2-2.2 4.3-3.6 6.2-1.4 1.9-3 3.7-4.7 5.4l-.6.6-.7-.6c-1-1-2-1.9-3-2.9l1.7-.9c.5 3.3 1 6.6 1.3 10 .2 1.7.3 3.3.5 5-.1 1.6 0 3.3 0 5zM394.2 292.4c-2.5-4.2-4.8-8.6-7-13s-4.3-8.8-6.2-13.4c-.9-2.3-1.9-4.6-2.6-7-.6-2.4-1.2-4.8-1.6-7.3-.4-2.4-.7-4.9-.7-7.4 0-1.2 0-2.5.2-3.7.2-1.2.5-2.5 1.1-3.6-.4 1.2-.5 2.4-.5 3.6 0 1.2.1 2.4.2 3.6.3 2.4.8 4.8 1.3 7.2.6 2.4 1.2 4.7 1.9 7s1.7 4.5 2.6 6.8l5.8 13.5c1.9 4.6 3.7 9.1 5.5 13.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M372.7 268.3c.9-1.7 2.1-3.2 3.3-4.7 1.2-1.5 2.5-2.9 4.1-4.1-.9 1.7-2.1 3.2-3.3 4.7-1.3 1.5-2.6 2.9-4.1 4.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065053858770881166350000018005726734838103434_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.341,
    y1: 269.275,
    x2: 340.185,
    y2: 269.074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e99671"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#f2a77c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9b384"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065053858770881166350000018005726734838103434_)"
    },
    d: "m355.1 264.2-33.3-.3s-2.1-1.3-6.1-3c-4-1.7-4.4 1.7-3.1 2.4 1.3.7 8.8 3.4 5.5 9.7l36.8 4.7.2-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 284.7c.6-1.4 1.3-2.6 2.1-3.8l.3-.4c.1-.2.1-.3.3-.5.2-.4.6-.7.9-.9.7-.4 1.5-.6 2.2-.5-.6.4-1.3.7-1.8 1.2-.2.2-.4.4-.5.7 0 .1-.1.3-.2.5s-.2.3-.3.5c-.4.6-.8 1.2-1.3 1.8-.6.4-1.1.9-1.7 1.4z",
    style: {
      fill: "#fdf1f6"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153 283.4s-.1 15.8-7.5 19.9c-7.4 4.1-13.5 3.8-16.8.8-3.3-3-4.3-15.6-1.9-18.9.1-.1.1-.2.2-.2 2.6-2.9 1.2-5.5 5.1-7.2 4-1.7 8.8 0 8.8 0l6.7 1.1 3.5-.9c.1-.1 3.7 2.7 1.9 5.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M148.4 268.6s-7.9-8.2-20.6-3.5c-15 5.5-16.4 28.1-5.1 30.5 0 0-5.6-7.3-3.3-8.3 0 0 2.6-1.6 4.9-.2l2.8-2.1.7-1.1 2.1-3.7s1.4-2.1 3-1.3c1.5.8 3.2 2.9 10 1.9s10-1.9 9-7.1c-.2-.4-1.2-3.2-3.5-5.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127 284.9s-1.4 1.5-2.8 2.1c0 0-2.2-1.7-5 .4s-.7 7 3.1 7.5l-3.6 7.6s-.2 4.1 5.9 6.1 8.3.5 10.5-2.1c0 0-4.6-.8-6-2.5-1.4-1.8-4.4-9.3-2.1-19.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M121.1 288.4s2.5.2 1.8 2.2-2.8 1.2-2.8 1.2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M115.1 292.5s-8.6 1.2-11.3 6.8c-2.7 5.6-5 16.4-5 16.4s5.9-8.3 11.2-10.7c5.3-2.3 9.6-2.9 9.6-2.9l1.9-5.5c0 .1-4.4.3-6.4-4.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008859336327234686370000014003627858040247443_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.054,
    y1: 293.965,
    x2: 122.048,
    y2: 293.965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e08926"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    style: {
      stopColor: "#e9a338"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    style: {
      stopColor: "#f0b948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    style: {
      stopColor: "#f4c652"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f6cb55"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008859336327234686370000014003627858040247443_)"
    },
    d: "M116.6 290.6s-2-.1-1.5 2.1c0 0 1.6 3.4 6.2 4.6l.7-2.1s-4.8-2.5-5.4-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7 269c-.3 0-.5-.1-.7-.4-.3-.4-.2-1 .2-1.3 6.6-5.1 12.1-.4 12.2-.3.4.3.4.9.1 1.3-.3.4-.9.4-1.3.1-.2-.2-4.4-3.8-9.8.4-.3.2-.5.2-.7.2z",
    style: {
      fill: "#4b5964",
      stroke: "#4b5964",
      strokeMiterlimit: 10
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 126.9,
    cy: 269.3,
    r: 1.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M152.8 285.7s1.5-4.3-2.6-7c0 0 4.3-4.5-1.9-10.1 0 0 7.3.8 6.8 8.5-.5 7.8-2.3 8.6-2.3 8.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M132 284.9s1.3-.8 2.3-.5 1.9.2 2.1-.2c.2-.4.1-1.2-1.2-1.3-1.2 0-2.7.2-3.2 2zM151.3 289.8s-.4-1.3-1.7-1.7c-1.3-.3-1.7-1.2-1.6-1.6.1-.5 1.2-.9 2.5.2 1.4 1.3.8 3.1.8 3.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 295.7s.8.8 1.9 0c1.1-.8 1.1 0 1.1 0s-.6 1-1.7.9c-1.2-.1-1.3-.9-1.3-.9z",
    style: {
      fill: "#c77a5a"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 137.8,
    cy: 300.8,
    r: 1.7
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M136.1 300.8s1.9-.5 2.1 1.7c.1 0-2.1.4-2.1-1.7z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 133.8,
    cy: 289.7,
    r: 2.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 134,
    cy: 290.2,
    r: 2.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 134.7,
    cy: 291.1,
    r: 0.9
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 147.3,
    cy: 293.4,
    r: 2.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 147.5,
    cy: 293.8,
    r: 2.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 148.2,
    cy: 294.7,
    r: 0.9
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M152.9 285.6c0 2.6-.2 5.2-.7 7.8-.2 1.3-.6 2.6-1 3.8-.5 1.2-1.1 2.5-2 3.5-.9 1-1.9 1.8-3 2.7-1.1.8-2.2 1.5-3.5 2-1.2.5-2.5.8-3.8 1-1.3.1-2.6.2-3.9.2 1.3-.2 2.6-.3 3.8-.7 1.3-.3 2.5-.7 3.6-1.2 2.3-1.1 4.2-2.8 6-4.6.8-.9 1.4-2 1.9-3.2.5-1.2.8-2.4 1.2-3.6.3-1.2.6-2.5.8-3.8.2-1.4.4-2.6.6-3.9zM124.2 287c1.2-.8 2.1-1.9 2.9-3 .4-.6.8-1.1 1.1-1.7.3-.6.6-1.2.9-1.9.2-.4.4-.7.7-1 .3-.3.6-.6 1-.7.4-.2.8-.3 1.2-.2.4 0 .8.3 1 .5-.4-.1-.7-.2-1.1-.1-.3 0-.6.2-.9.4-.3.2-.5.5-.7.7-.2.3-.4.6-.5.9-.4 1.4-1.1 2.7-2.1 3.9-.5.6-1 1.1-1.7 1.5-.4.2-1.1.6-1.8.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M147.5 373.3s-20.3 22.8-59.9 23.9c.3 4 .5 7.9.5 11.9 28-1.9 90.4-9 97.6-34 .1 0 7.7-10.8-38.2-1.8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.6 306.3s11.4 6.4 11.6 20.3l.2 13.9v24.8l-48.9-.9 2.1-29.7 4.8-26.9s8.7-6 14.1-5.6c0 0-.6 4 6.7 5.6 7.4 1.6 9.4-1.5 9.4-1.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m135 306.5-2 1.4 3.5 3 1.3-4.7zM118.1 301.7l11.8 6.2-5.5 5.7-8.2-9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M99.3 388.1s-.8-5.4 4-8.3c4.8-2.9 10.7-2.8 16.5-.2l27-10.7v-3.6l-43.2-.6-8.8.7s-14.7 19.4 4 28.3l.5-5.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M133.8 370c-2.7-2.1-5.4-4.3-8-6.6l-.4-.3.3-.5c.2-.3.4-.8.6-1.3.2-.5.3-1 .5-1.4.3-1 .6-2 .8-3 .2-1 .4-2 .6-3.1l.4-3.1c.5-4.1.7-8.3 1-12.5.1-4.2.3-8.4.3-12.6l.1-6.3c0-2.1 0-4.2.1-6.3.6 4.2 1 8.4 1.2 12.6.3 4.2.3 8.4.2 12.7-.1 4.2-.4 8.5-1 12.7l-.6 3.2c-.2 1-.4 2.1-.7 3.1-.3 1-.6 2.1-1 3.1s-.8 2-1.5 3l-.1-.8c2.4 2.4 4.8 4.9 7.2 7.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "m133.8 370 7.6-8s2.2-33.4-7-50.8c0 0-1.8 2-4.4 1.9 0 0 2.9 31.3-3.8 50l7.6 6.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M85.2 395.6s32.5 1.2 49.3-6.7l5.5 17.3s-51.5 4.2-58 2.8l3.2-13.4z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M143.8 316.4c1 1.8 1.8 3.7 2.6 5.6.8 1.9 1.4 3.8 2 5.8.5 2 1 4 1.3 6 .3 2 .3 4.1 0 6.2 0-2.1-.4-4-.8-6s-.9-3.9-1.5-5.9c-.5-2-1.1-3.9-1.7-5.8l-1.9-5.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M128 310s1 3.5 2.5 3.7c1.4.2 4.4-1.9 4.4-1.9l.6-1.5-2.4-2.4-2.4.4-.9-.4-1.8 2.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M134.8 311.8c-.6.7-1.4 1.2-2.3 1.5-.5.1-.9.2-1.4.3-.5 0-.9 0-1.4-.1h-.1l-.1-.1c-.3-.3-.5-.5-.7-.8-.2-.3-.4-.5-.5-.8-.3-.6-.5-1.2-.7-1.8l-.1-.2.1-.1c.7-.6 1.3-1.3 2.1-1.8-.4.8-1 1.6-1.5 2.3l.1-.4c.3.5.5 1.1.8 1.5.1.2.3.5.5.7.2.2.4.5.5.6l-.2-.1c.4.1.8.1 1.2.1.4 0 .8 0 1.3-.1.8 0 1.6-.2 2.4-.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m155.5 350.5-7.5 3.8s-2.5-38.6-10.5-47.2c0 .1 15.4 6.2 18 43.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M138.6 313.6c2.1 2.5 3.7 5.3 5 8.3 1.4 2.9 2.4 6 3.3 9.2.8 3.2 1.4 6.3 1.7 9.6.2 1.6.2 3.2.3 4.8 0 1.6 0 3.2-.1 4.8l-.6-4.8-.3-2.4c-.1-.8-.2-1.6-.4-2.4-.1-.8-.3-1.6-.4-2.4-.1-.8-.3-1.6-.5-2.3-.3-1.6-.7-3.1-1.1-4.6-.8-3.1-1.8-6.1-2.9-9.1-1.2-2.9-2.4-5.9-4-8.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M188.3 395.4s-55-2.7-60.5-10.1-19.1-10.6-24.1-9.7c-8.8 1.6-18.3 18.1 15.3 26.6 33.6 8.6 71 5.5 71 5.5s20.9-.2 23.2-12.1l-24.9-.2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186.8 395.4h26.9s0 14-24.8 12.3l-2.1-12.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M122.1 380.4s-21 4.1-18.8 15.8c0 0-16.9-7-6.6-18.4 10.3-11.5 25.4 2.6 25.4 2.6z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M129.9 386.9s31.6-24.3 41.2-11.7c9.6 12.6 0 15.6 0 15.6s24.5-12.7 12.5-21.1c-12-8.4-25.5-5.1-25.5-5.1l-36.7 11.7-2.9 3.8 11.4 6.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M188.9 407.7s-16.6 2.2-44.9-1l3.5-15.2s32 3.9 39.3 3.9l2.1 12.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m85.2 395.6-26.1-1s-3.9 12.3 22.8 14.4l3.3-13.4z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M147.5 391.5c-3.2-.1-6.4-.6-9.6-1.3-1.6-.4-3.1-.8-4.7-1.4-1.5-.6-3.1-1.3-4.2-2.4 1.4.8 3 1.2 4.5 1.7 1.5.4 3.1.8 4.7 1.2 3 .6 6.2 1.3 9.3 2.2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M85.2 395.6c2.7-.4 5.4-.6 8.1-.6 2.7 0 5.4 0 8.1.4-2.7.4-5.4.6-8.1.6-2.7 0-5.4 0-8.1-.4zM149.1 391.7c3.2.1 6.3.4 9.4.6 3.1.2 6.3.6 9.4.9 3.1.3 6.3.7 9.4 1l4.7.6c1.6.2 3.1.4 4.7.6-3.2 0-6.3-.2-9.5-.4-3.1-.2-6.3-.5-9.4-.8-3.1-.3-6.3-.7-9.4-1.1-3-.4-6.2-.9-9.3-1.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.1 347.1s1.6 9.5-2 12.5c0 0-1.9-5.8 2-12.5z",
    style: {
      fill: "#d1cbcb"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M137.1 347.1s-3.8 7.1-2 12.5l-33.3 9.3s-9.3 1.8-11.3-4.6c-1.9-6.4-1.9-13.7-.5-23.7 1.3-10 12.3-39.7 20.6-32.2 6.7 6.1-1.6 19.9-1.6 19.9s-6.8 17.1-5.7 24.7l33.8-5.9z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M142.7 356.2s1.6 4.3 4.7 5.5l4.9-10.7s-3.5-4.3-7.7-4c-4.3.4-6.5.7-8.2 1.7 0 0-1.3 2.4-1.5 5.2-.1 0 1 3.8 7.8 2.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078009053121383376840000013273944740179865746_",
    gradientUnits: "userSpaceOnUse",
    x1: -1207.118,
    y1: -1320.247,
    x2: -1279.678,
    y2: -1241.807,
    gradientTransform: "matrix(-.6178 -.1672 -.3101 1.146 -999.946 1598.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5d609",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    style: {
      stopColor: "#f8dd07",
      stopOpacity: 0.3276
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    style: {
      stopColor: "#fe0",
      stopOpacity: 0.771
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#478dcb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "url(#SVGID_00000078009053121383376840000013273944740179865746_)"
    },
    d: "m187.6 255.7 39.5 75-79.7 34.6-53.9-69.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120520779606218443510000003605954832732408499_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.383,
    y1: 347.13,
    x2: 105.852,
    y2: 347.13,
    gradientTransform: "matrix(-1 0 0 1 251.106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a4a4b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#9c9cae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#878795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#65656b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120520779606218443510000003605954832732408499_)"
    },
    d: "m145.3 365.3 3.8 3.3 16.6-40.8-3.2-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.5 368.8-1.2-2.1c-.6.8-1.4 1.5-2.4 1.8 0 2-.2 2.3-.2 2.3h63.1c.6-.5.8-2.1.8-2.1h-60.1z",
    style: {
      fill: "#b4b4c0"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091726739799707527710000010392306948998724758_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.802,
    y1: 348.356,
    x2: 102.455,
    y2: 348.356,
    gradientTransform: "matrix(-1 0 0 1 251.106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    style: {
      stopColor: "#d0d1d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    style: {
      stopColor: "#cecfd7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    style: {
      stopColor: "#c6c7ce"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    style: {
      stopColor: "#b8b9c0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    style: {
      stopColor: "#a5a6ac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    style: {
      stopColor: "#8d8d92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    style: {
      stopColor: "#6f6f73"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091726739799707527710000010392306948998724758_)"
    },
    d: "m230.3 328.2-64.6-.4-17.1 40.1 1 1c.1 0 .2.1.3.1h60.8c.4 0 .7-.2.8-.5l18.8-40.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114783787743697079140000001448554809925081784_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.802,
    y1: 326.927,
    x2: 88.588,
    y2: 326.927,
    gradientTransform: "matrix(-1 0 0 1 251.106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a4a4b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#9c9cae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#878795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#65656b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114783787743697079140000001448554809925081784_)"
    },
    d: "M196.5 325.7h-34l3.2 2.1 64.6.4-3.1-2.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114060115001978989610000004973378862690250651_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.616,
    y1: 350.504,
    x2: 65.803,
    y2: 350.504,
    gradientTransform: "matrix(-1 0 0 1 251.106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a4a4b8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    style: {
      stopColor: "#9c9cae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    style: {
      stopColor: "#878795"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#65656b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#59595c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114060115001978989610000004973378862690250651_)"
    },
    d: "M189.7 355.3h-.5c-1-.1-3.9-.6-3.9-3 0-2.9 2.5-5.5 5.6-6.4 1.6-.5 3.1-.1 4.3.3 2.1.8 3 3.4 1.8 5.3v.1c-1.7 2.6-4.9 3.6-7.3 3.7z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M109.5 307.6c.8.8 1.1 1.8 1.4 2.9.3 1 .3 2.1.4 3.2.1 2.1 0 4.3-.4 6.4-.6 4.2-1.6 8.4-2.8 12.4-1.2 4.1-2.6 8-3.7 12.1-.6 2-1.1 4-1.4 6.1-.2 1-.3 2-.3 3 0 .5.1 1 .2 1.2.1.1 0 .1.1.1 0 0 .2-.1.3-.1l.1-.1h.1c4-1.5 8-2.8 12.1-4 2-.6 4.1-1.1 6.2-1.5 2.1-.4 4.2-.7 6.3-.6-2.1.1-4.2.5-6.2 1.1l-6 1.8c-4 1.3-7.9 2.8-11.8 4.4l.2-.1c-.3.2-.7.4-1.2.4s-1-.4-1.2-.7c-.4-.7-.4-1.3-.5-1.9-.1-1.2.1-2.2.3-3.3.4-2.1.9-4.2 1.4-6.2 1.1-4.1 2.6-8.1 3.9-12.1 1.3-4 2.5-8 3.3-12.1l.3-1.5.2-1.6c.1-.5.1-1 .2-1.6 0-.5.1-1 .1-1.6 0-1 0-2.1-.2-3.1-.5-1.1-.7-2.1-1.4-3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95959b"
    },
    d: "m145.3 365.3-1.8 1.4 4.3 4.2 1.5-2.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundError);
export default __webpack_public_path__ + "static/media/not-found-error.42397f14dfa841d3885f3d916989f0c9.svg";
export { ForwardRef as ReactComponent };